import { SVGProps, Ref, forwardRef } from 'react';

export const CarFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 8.5c9 0 10 .962 11 6.25v5.33c0 .857 0 1.286-.13 1.628a2 2 0 0 1-1.162 1.163c-.342.13-.771.129-1.629.129-.766 0-1.15 0-1.468-.11a2 2 0 0 1-1.14-1.006c-.117-.239-.171-.526-.236-1.012v-.005C15.848 20.965 14.13 21 12 21s-3.85-.035-5.235-.133l-.001.005q-.024.18-.048.33c-.048.296-.1.503-.188.682a2 2 0 0 1-1.14 1.007c-.317.11-.7.109-1.467.109-.858 0-1.287 0-1.629-.129a2 2 0 0 1-1.162-1.163C1 21.366 1 20.938 1 20.079V14.75C2 9.462 3 8.5 12 8.5m-5.75 4.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m11.5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M9.3 15.4h5.4v-1.8H9.3z"
            fill="currentColor"
        />
        <path
            d="M12 1c6.12 0 7.684.734 8.501 6.642-.856-.348-1.826-.56-2.901-.695C16.108 6.76 14.265 6.7 12 6.7s-4.108.06-5.6.247c-1.076.136-2.046.348-2.903.696C4.314 1.734 5.88 1 12 1"
            fill="currentColor"
        />
    </svg>
));
CarFilledSize24Glyph.displayName = 'CarFilledSize24Glyph';
